// LiveCountdown — segmented "tiles" variant (lcd-). Injected once via
// components/styles/componentStyles.ts. The compact variant is plain inline text and
// needs no class here.
export const liveCountdownStyles = `
  .lcd-tiles {
    display: inline-flex;
    align-items: flex-start;
    gap: var(--space-2);
  }
  .lcd-tile {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 58px;
    padding: 8px 8px 6px;
    background: var(--catchup-white);
    border: 1px solid var(--catchup-gray-100);
    border-style: solid;
    border-radius: var(--rad-catchup-medium);
    box-shadow: 0 2px 6px rgba(20, 40, 60, 0.06);
  }
  .lcd-tile-num {
    font-size: var(--fs-2xl);
    font-weight: var(--font-weight-bold);
    line-height: 1.05;
    color: var(--catchup-gray-600);
    font-variant-numeric: tabular-nums;
  }
  .lcd-tile-lbl {
    margin-top: 3px;
    font-size: var(--fs-xs);
    font-weight: var(--font-weight-bold);
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: var(--catchup-gray-400);
  }
`;
